// extracted by mini-css-extract-plugin
export default {"mainWrapper":"styles_mainWrapper__ZgIb-","container":"styles_container__ul0To","bannerContent":"styles_bannerContent__8FbJb","backgroundImage":"styles_backgroundImage__rIejd"};